'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dTwo$002dFactor$002dAuth$0024 from "./presto.-List-Two-Factor-Auth$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002467 from "./presto.-Presto-Router$$anon$67.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024 from "./presto.types$-Credential-Name$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$66() {
  this.bmD = null;
  this.bmv = null;
  this.bmw = false;
  this.bmE = null;
  this.bmF = false;
  this.bmI = null;
  this.bmB = null;
  this.bmC = false;
  this.bmx = null;
  this.bmy = false;
  this.bmz = null;
  this.bmA = false;
  this.bmG = false;
  this.bmH = false;
  this.bmD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bmI = "ListTwoFactorAuth";
}
export { $c_Lpresto_PrestoRouter$$anon$66 as $c_Lpresto_PrestoRouter$$anon$66 };
$p = $c_Lpresto_PrestoRouter$$anon$66.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$66;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$66() {
}
export { $h_Lpresto_PrestoRouter$$anon$66 as $h_Lpresto_PrestoRouter$$anon$66 };
$h_Lpresto_PrestoRouter$$anon$66.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bmD;
});
$p.M = (function() {
  if ((!this.bmw)) {
    this.bmv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bmw = true;
  }
  return this.bmv;
});
$p.O = (function() {
  if ((!this.bmF)) {
    this.bmE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bmF = true;
  }
  return this.bmE;
});
$p.D = (function() {
  return this.bmI;
});
$p.t = (function() {
  if ((!this.bmC)) {
    this.bmB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("url", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bmC = true;
  }
  return this.bmB;
});
$p.N = (function() {
  if ((!this.bmy)) {
    this.bmx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dCredential$002dName$0024.$m_Lpresto_types$CredentialName$().gr())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fi())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bmy = true;
  }
  return this.bmx;
});
$p.Q = (function() {
  if ((!this.bmA)) {
    this.bmz = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002467.$c_Lpresto_PrestoRouter$$anon$67();
    this.bmA = true;
  }
  return this.bmz;
});
$p.v = (function() {
  if ((!this.bmH)) {
    this.bmG = false;
    this.bmH = true;
  }
  return this.bmG;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee480) => ((p) => \u03b4scrutinee480.cH9(p)))($j_presto$002e$002dList$002dTwo$002dFactor$002dAuth$0024.$m_Lpresto_ListTwoFactorAuth$())));
});
var $d_Lpresto_PrestoRouter$$anon$66 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$66, "presto.PrestoRouter$$anon$66", ({
  OH: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$66 as $d_Lpresto_PrestoRouter$$anon$66 };
//# sourceMappingURL=presto.-Presto-Router$$anon$66.js.map
